import dayjs from "dayjs";
import { ICreateFornecedorUseCase } from "../../../presentation/useCases/create/create_fornecedor_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateFornecedorUseCase
 */

export class CreateFornecedorUseCase implements ICreateFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createFornecedor(
    idCentroCusto: number | null,
    dataCadastro: Date | null,
    razaoSocial: string,
    nomeFantasia: string,
    cnpj: string,
    cpf: string,
    inscricaoEstadual: string,
    inscricaoMunicipal: string,
    atividade: string,
    obsFornecedor: string,
    contato: string,
    telefoneFixo: string,
    telefoneCelular: string,
    email: string,
    contato1: string,
    email1: string,
    descQualificacoes: string,
    fornProduto: boolean,
    fornServico: boolean,
    familia: string,
    ativo: boolean,
    avaliar: boolean,
    avaliacaoFinanceira: string,
    dataValidade: Date | null,
    rua: string,
    numero: string,
    apartamento: string,
    cep: string,
    uf: string,
    cidade: string,
    bairro: string,
    pais: string,
    qualificacoes: {
      idQualificacao: number,
      qualificado: boolean,
      observacao: string,
    }[],
  ): Promise<number> {
    return await this.repository.createFornecedor(
      idCentroCusto,
      dataCadastro,
      razaoSocial,
      nomeFantasia,
      cnpj,
      cpf,
      inscricaoEstadual,
      inscricaoMunicipal,
      atividade,
      obsFornecedor,
      contato,
      telefoneFixo,
      telefoneCelular,
      email,
      contato1,
      email1,
      descQualificacoes,
      fornProduto,
      fornServico,
      familia,
      ativo,
      avaliar,
      avaliacaoFinanceira,
      dataValidade,
      rua,
      numero,
      apartamento,
      cep,
      uf,
      cidade,
      bairro,
      pais,
      qualificacoes.filter(x => x.qualificado === true),
    );
  }

  async createFornecedorSimplificado(
    ativo: number,
    avaliarFornecedor: number,
    fornecedorProdutos: number,
    fornecedorServicos: number,
    nomeFantasia: string,
    razaoSocial: string | null,
    centroCusto: number | null,
    cnpj: string | null,
    cpf: string | null,
    observacoes: string | null,
    qualificacao: {
      idQualificacao: number,
      qualificado: boolean,
      observacao: string,
    }[],
  ): Promise<number> {
    const dataCadastro = dayjs().local().utc().toDate();
    const inscricaoEstadual = '';
    const inscricaoMunicipal = '';
    const atividade = '';
    const obsFornecedor = observacoes;
    const contato = '';
    const telefoneFixo = '';
    const telefoneCelular = '';
    const email = '';
    const contato1 = '';
    const email1 = '';
    const descQualificacoes = '';
    const fornProduto = fornecedorProdutos;
    const fornServico = fornecedorServicos;
    const familia = '';
    const avaliar = avaliarFornecedor;
    const avaliacaoFinanceira = '';
    const dataValidade = null;
    const rua = '';
    const numero = '';
    const apartamento = '';
    const cep = '';
    const uf = '';
    const cidade = '';
    const bairro = '';
    const pais = '';
    const qualificacoes = qualificacao.filter(x => x.qualificado === true);

    return await this.repository.createFornecedor(
      centroCusto,
      dataCadastro,
      razaoSocial ?? '',
      nomeFantasia,
      cnpj ?? '',
      cpf ?? '',
      inscricaoEstadual,
      inscricaoMunicipal,
      atividade,
      obsFornecedor ?? '',
      contato,
      telefoneFixo,
      telefoneCelular,
      email,
      contato1,
      email1,
      descQualificacoes,
      fornProduto === 1,
      fornServico === 1,
      familia,
      ativo === 1,
      avaliar === 1,
      avaliacaoFinanceira,
      dataValidade,
      rua,
      numero,
      apartamento,
      cep,
      uf,
      cidade,
      bairro,
      pais,
      qualificacoes,
    );
  }
}
